import {REPORTS_SUCCESS,REPORTS_REQUEST,REPORTS_ERROR} from "../actions/reportsActions"

let initialState = {
    data:[],
    fetching:false,
    set:false,
}

export default function reports(state = initialState, action){
    switch (action.type){
        case REPORTS_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case REPORTS_SUCCESS:
            return{
                ...state,
                fetching:false,
                data:action.payload
            }
        case REPORTS_ERROR:
            return{
                ...state,
                fetching:false,
                data:[]
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/reports.js